<template>
  <div class="my-order" ref="container">
    <div class="promoterHeader bg-color-red">
      <div class="headerCon acea-row row-between-wrapper">
        <div>
          <div class="name">累计订单</div>
          <div>
            <span class="num">{{ count }}</span
            >单
          </div>
        </div>
        <div class="iconfont icon-2"></div>
      </div>
    </div>
    <div class="list">
      <div class="item" v-for="order in list" :key="order.id">
        <div class="title acea-row row-between-wrapper">
          <div class="acea-row row-middle">
            <img
              class="logo"
              v-if="order.pay_user_avatar"
              :src="order.pay_user_avatar"
            />
            <img class="logo" v-else src="@assets/images/writeOff.jpg" />
            <span>
              {{ order.buy_user_name }}
            </span>
          </div>
          <div class="font-color-red">{{ order.status_msg || "订单状态" }}</div>
        </div>
        <div @click="$router.push({ path: '/order/detail/' + order.id })">
          <div
            class="item-info acea-row row-between row-top"
            v-for="(cart, index) in order.snapshot"
            :key="index"
          >
            <div class="pictrue">
              <img
                :src="cart.productInfo.img"
                @click.stop="
                  $router.push({ path: '/detail/' + cart.productInfo.id })
                "
                v-if="cart.productInfo.img"
              />
              <img
                v-else
                src="@assets/images/noGood.png"
                @click.stop="
                  $router.push({ path: '/detail/' + cart.productInfo.id })
                "
              />
            </div>
            <div class="text acea-row row-between">
              <div class="name line2">
                {{ cart.productInfo.title || "" }}
              </div>
              <div class="money">
                <div>￥{{ cart.truePrice }}</div>
                <div>x{{ cart.cart_num }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="totalPrice">
          共{{ order.snapshot.length || 0 }}件商品，<span
            v-if="order.pay_postage"
            >运费 ￥{{ order.pay_postage }}，</span
          >总金额
          <span class="money font-color-red">￥{{ order.pay_price }}</span>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import { getSpreadSubOneOrder } from "../../../api/user";
import Loading from "@components/Loading";
export default {
  name: "PromoterOrder",
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      list: [],
      where: {
        page: 1,
        page_size: 15,
        sub_id: 0
      },
      loaded: false,
      loading: false,
      loadTitle: "",
      count: "",
      userInfo: {}
    };
  },
  watch: {
    $route(to) {
      if (to.name != "PromoterOrder") return;
      this.loaded = false;
      this.where = {
        page: 1,
        page_size: 15,
        sub_id: to.params.id || 0
      };
      this.list = [];
      this.count = 0;
      this.getIndex();
    }
  },
  mounted: function() {
    this.where.sub_id = this.$route.params.id || 0;
    this.getIndex();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getIndex();
    });
  },
  methods: {
    getIndex: function() {
      let there = this;
      if (there.loaded == true || there.loading == true) return;
      there.loading = true;
      getSpreadSubOneOrder(there.where).then(
        res => {
          there.loading = false;
          there.loaded = !res.data || res.data.length < there.where.page_size;
          there.loadTitle = there.loaded ? "人家是有底线的" : "上拉加载更多";
          there.where.page = there.where.page + 1;
          there.list.push.apply(there.list, res.data);
          there.count = res.total;
        },
        error => {
          there.$dialog.message(error.msg);
        },
        300
      );
    }
  }
};
</script>

<style scoped>
.noCart {
  margin-top: 0.17rem;
  padding-top: 0.1rem;
}

.noCart .pictrue {
  width: 4rem;
  height: 3rem;
  margin: 0.7rem auto 0.5rem auto;
}

.noCart .pictrue img {
  width: 100%;
  height: 100%;
}
</style>
